module.exports = __webpack_public_path__ + "static/media/vampiress_circle.cae45dad.png";